/**
 * Version simplifiée de Stories.js qui n'utilise pas du tout les composants problématiques
 */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "./context/AppContext";

// Version ultra-simplifiée qui évite tout composant externe
const StoriesMock = () => {
  const { id } = useContext(AppContext);
  const navigate = useNavigate();
  
  // Effet qui simule le comportement de Stories.js
  useEffect(() => {
    // Simuler un délai puis naviguer vers les plans
    const timer = setTimeout(() => {
      navigate("/Plans");
    }, 500);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="fixed inset-0 w-full h-full bg-black flex items-center justify-center">
      <div className="text-center p-8 bg-indigo-900 rounded-xl max-w-md mx-auto text-white">
        <h1 className="text-3xl font-bold mb-4">Bienvenue sur Kapella</h1>
        <p className="mb-6">Chargement de votre expérience...</p>
        <div className="w-12 h-12 border-4 border-t-indigo-300 border-indigo-500 rounded-full animate-spin mx-auto"></div>
      </div>
    </div>
  );
};

export default StoriesMock;